// extracted by mini-css-extract-plugin
module.exports = {"knowledge_content":"knowledge__knowledge_content___2Y9NS","flex_box":"knowledge__flex_box___1hUwo"};